// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px){
  .dividers{
    flex-wrap: wrap;
    flex-direction: column;
  }
}

.imageRows{
    margin-top: 40px;
    display: flex;
    justify-content: center;
    border: 1px solid rgb(186, 35, 35);
}
.Row1{
    height: 300px;
}
.Container{
    text-align: center;
    color: rgb(0, 0, 0);
}
.Caption {
  font-size: 24px;
  background-color: grey;
  border-right: 1px solid red;
  border-left: 1px solid red;
}

.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}
/* Create four equal columns that sits next to each other */
.column {
  flex: 25% 1;
  max-width: 25%;
  padding: 0 4px;
}
.column img {
  margin-top: 8px;
  vertical-align: middle;
  width: 100%;
}

/* makes the columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .column {
    flex: 100% 1;
    max-width: 100%;
  }
}

#bibleVerse{
  font-size: 30px;
  font-style: italic;
  background-color: antiquewhite;
}

.infoTable{
    margin-left: auto;
    margin-right: auto;
    border-spacing: 10px;
    background-color: #111111;
}
table, th, td {
  border: 1px solid rgb(255, 255, 255);
}`, "",{"version":3,"sources":["webpack://./src/CSS/About.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,kCAAkC;AACtC;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA,2DAA2D;AAC3D;EACE,WAAS;EACT,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;;AAEA,+EAA+E;AAC/E;EACE;IACE,YAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;AAC7B;AACA;EACE,oCAAoC;AACtC","sourcesContent":["@media (max-width: 768px){\n  .dividers{\n    flex-wrap: wrap;\n    flex-direction: column;\n  }\n}\n\n.imageRows{\n    margin-top: 40px;\n    display: flex;\n    justify-content: center;\n    border: 1px solid rgb(186, 35, 35);\n}\n.Row1{\n    height: 300px;\n}\n.Container{\n    text-align: center;\n    color: rgb(0, 0, 0);\n}\n.Caption {\n  font-size: 24px;\n  background-color: grey;\n  border-right: 1px solid red;\n  border-left: 1px solid red;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 4px;\n}\n/* Create four equal columns that sits next to each other */\n.column {\n  flex: 25%;\n  max-width: 25%;\n  padding: 0 4px;\n}\n.column img {\n  margin-top: 8px;\n  vertical-align: middle;\n  width: 100%;\n}\n\n/* makes the columns stack on top of each other instead of next to each other */\n@media screen and (max-width: 600px) {\n  .column {\n    flex: 100%;\n    max-width: 100%;\n  }\n}\n\n#bibleVerse{\n  font-size: 30px;\n  font-style: italic;\n  background-color: antiquewhite;\n}\n\n.infoTable{\n    margin-left: auto;\n    margin-right: auto;\n    border-spacing: 10px;\n    background-color: #111111;\n}\ntable, th, td {\n  border: 1px solid rgb(255, 255, 255);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
